import { Box, Button, Stack } from '@dtx-company/design-system/src'
import { DeleteOutline, Save } from '@mui/icons-material'
import { FC } from 'react'
import { LinkProvider } from '@dtx-company/inter-app/src/constants/linkTypes'
import { LinkType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { clearPreviewLink } from '@dtx-company/inter-app/src/redux/slices/linkEditor/linkEditorSlice'
import { css, styled } from '@mui/system'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'
import { useDeleteLinkWithAutosave } from '../deleteUtils'
import { useDispatch } from 'react-redux'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

interface SettingsProps {
  curr?: LinkType
  singleCol?: boolean
  handleClose(): void
  disabled?: boolean
  deleteAction?: () => void
  linkTypeText?: string
  initialSaveActionText?: string
}

export const SettingsWrapper = styled(Box)<{ singleCol: boolean }>`
  @media (max-width: 1024px) {
    position: fixed;
    bottom: 10px;
    width: 90%;
    z-index: 1000;
  }

  ${props =>
    !props.singleCol &&
    css`
      @media (min-width: 1024px) {
        position: absolute;
        bottom: 20px;
        left: calc(50% + 12px);
        width: calc(50% - 50px);
      }
    `}
`

export const SettingsAndSaveLink: FC<SettingsProps> = ({
  curr,
  handleClose,
  disabled = false,
  linkTypeText = 'Link',
  initialSaveActionText = 'Save'
}: SettingsProps) => {
  const dispatch = useDispatch()
  const page = useCurrentPage()
  const deleteLink = useDeleteLinkWithAutosave()
  const saveButtonLabel = curr ? `Save ${linkTypeText}` : `${initialSaveActionText} ${linkTypeText}`
  const isExistingLink = curr && page?.links?.some(link => link.id === curr.id)

  const onClickTwo = async (): Promise<void> => {
    if (!curr) return

    try {
      deleteLink({
        linkId: curr.id,
        linkOrder: curr.order
      })
      curr.provider === LinkProvider.WIDGET
        ? events.userDeletedWidget({ link_id: curr.id })
        : events.userDeletedLink({ link_id: curr.id })

      handleClose()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Stack direction="row" justifyContent="space-between" gap={2}>
      {isExistingLink ? (
        <Button fullWidth onClick={onClickTwo} startIcon={DeleteOutline}>
          {`Delete ${linkTypeText}`}
        </Button>
      ) : (
        <Button
          fullWidth
          onClick={async () => {
            try {
              dispatch(clearPreviewLink({}))
              handleClose()
            } catch (err) {
              console.error(err)
            }
          }}
          startIcon={DeleteOutline}
        >
          {`Delete ${linkTypeText}`}
        </Button>
      )}

      <Button
        fullWidth
        startIcon={Save}
        color="tertiary"
        disabled={disabled}
        data-test="link-form-submit"
        type="submit"
      >
        {saveButtonLabel}
      </Button>
    </Stack>
  )
}
